import { createI18n } from "vue-i18n";
import store from "../store";
import { supportedLocales, resolveInitialLocale } from "./detectLocale";

// 适配语言 en 英文 zh 中文 ja 日语

// 根据模块去做语言适配
const modules = [
  "common",
  "index", // 新增首页模块
  "solutions", // 解决方案页面模块
  "solutionPlan", // 方案解决页面模块
  "cases", // 客户案例页面模块
  // "contact", // 联系我们页面模块（已下线）
];

// 语言包组装工厂
const messages = {};
for (let i = 0; i < supportedLocales.length; i++) {
  const locale = supportedLocales[i];
  messages[locale] = {};

  modules.forEach((moduleName) => {
    try {
      const moduleContent = require(`./mod/${moduleName}`).default;
      if (moduleContent && moduleContent[locale]) {
        messages[locale][moduleName] = moduleContent[locale];
      }
    } catch (error) {
      console.warn(
        `Language module ${moduleName} not found for locale ${locale}`
      );
    }
  });
}

// 创建 i18n 实例
const initialLocale = resolveInitialLocale();

const i18n = createI18n({
  locale: initialLocale,
  fallbackLocale: "en", // 回退语言
  legacy: false, // 使用 Composition API 模式
  globalInjection: true, // 全局注入 $t 函数
  messages,
});

// 设置初始语言的 body class
supportedLocales.forEach((locale) => {
  document.body.classList.remove(`lang-${locale}`);
});
document.body.classList.add(`lang-${i18n.global.locale.value}`);
document.documentElement.lang = i18n.global.locale.value;

// 国际化适配函数
export function $i18nAdapt(title, data) {
  const hasKey = i18n.global.te(title);
  const t = title.split(".");
  const name = t.length > 1 ? t[t.length - 1] : title;
  if (hasKey) {
    return i18n.global.t(title, data);
  }
  return name;
}

// 全局改变语言设置
export function $changeLang(locale) {
  if (!supportedLocales.includes(locale)) {
    console.warn(`Unsupported locale: ${locale}`);
    return;
  }

  i18n.global.locale.value = locale;

  // 更新 body class
  supportedLocales.forEach((lang) => {
    document.body.classList.remove(`lang-${lang}`);
  });
  document.body.classList.add(`lang-${locale}`);
  document.documentElement.lang = locale;

  // 存储到 vuex store（如果需要）
  if (store && store.commit) {
    store.commit("SET_LANGUAGE", locale);
  }
}

// 获取当前语言
export function getCurrentLocale() {
  return i18n.global.locale.value;
}

// 获取支持的语言列表
export function getSupportedLocales() {
  return supportedLocales;
}

export default i18n;
